import { c as _c } from "react/compiler-runtime";
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import { useTimeout } from 'usehooks-ts';
import type { CustomQuestionsFormData } from '../types';
const useFocusOnQuestion = questionIndex => {
  const $ = _c(11);
  const {
    control,
    setFocus
  } = useFormContext();
  const t0 = `questions.${questionIndex}`;
  let t1;
  if ($[0] !== control || $[1] !== t0) {
    t1 = {
      control,
      name: t0
    };
    $[0] = control;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const question = useWatch(t1);
  const t2 = `questions.${questionIndex}`;
  let t3;
  if ($[3] !== control || $[4] !== t2) {
    t3 = {
      control,
      name: t2
    };
    $[3] = control;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    errors
  } = useFormState(t3);
  let t4;
  if ($[6] !== errors || $[7] !== question?.kind || $[8] !== questionIndex || $[9] !== setFocus) {
    t4 = () => {
      if (question?.kind === "text_block") {
        setFocus(`questions.${questionIndex}.content`);
        return;
      }
      const questionErrors = errors.questions?.[questionIndex];
      if (questionErrors) {
        if ("label" in questionErrors && questionErrors.label) {
          setFocus(`questions.${questionIndex}.label`);
        } else {
          if ("dataIdentifier" in questionErrors && questionErrors.dataIdentifier) {
            setFocus(`questions.${questionIndex}.dataIdentifier`);
          } else {
            if ("content" in questionErrors && questionErrors.content) {
              setFocus(`questions.${questionIndex}.content`);
            } else {
              if ("options" in questionErrors && questionErrors.options) {
                const optionsErrors = questionErrors.options as Array<{
                  label?: unknown;
                }> | undefined;
                if (Array.isArray(optionsErrors)) {
                  const firstErrorIndex = optionsErrors.findIndex(_temp);
                  if (firstErrorIndex !== -1) {
                    setFocus(`questions.${questionIndex}.options.${firstErrorIndex}.label`);
                  }
                }
              } else {
                setFocus(`questions.${questionIndex}.label`);
              }
            }
          }
        }
      } else {
        setFocus(`questions.${questionIndex}.label`);
      }
    };
    $[6] = errors;
    $[7] = question?.kind;
    $[8] = questionIndex;
    $[9] = setFocus;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useTimeout(t4, 100);
};
export default useFocusOnQuestion;
function _temp(opt) {
  return opt?.label;
}